export interface OnReady {
  $onReady(): void | Promise<any>;
}
